module.exports = __webpack_public_path__ + "media/images/dashboard-subscribe-d8af307e.png";